import IQACDynamicPage from '../../DynamicPage/IQACDynamicPage';
import pages from "../../Pages.json";
import TableComponent from '../../../components/Table/TableComponent';
import "./WebsiteMaintenance.scss";

const WebsiteMaintenance = () => {

    const websiteMaintenance = pages['website-maintenance'][0];
    const columns = ["S.No.", "Name", "Designation & Department", "Position", "Email ID"];
    const rows = [
        { name: "Dr. R. Marimuthu", designation: "Principal", position: "Chairman", email: "nicollege2001@yahoo.co.in" },
        { name: "Dr. R. Rajalakshmi", designation: "Asst. Prof. &  Head, Department of Computer Science", position: "Convenor", email: "rajalakshminatesh@gmil.com" },
        { name: "Dr. S. Kala", designation: "Asst. Prof., Department of Computer Application", position: "Member", email: "kalajk1980@gmail.com" },
        { name: "Dr. T. O. Sunitha", designation: "Asst. Prof., Department of  Information Technology", position: "Member", email: "Sunithavimal80@gmail.com" },
        { name: "Mrs. K. Viji", designation: "Technical Assistant", position: "Member", email: "vg851104@gmail.com" },


    ];

    return (
        <section className="websiteMaintenanceMainContainer">
            <article className="firstSection">
                <IQACDynamicPage
                    title={websiteMaintenance.title}
                    content={websiteMaintenance.content}
                    secondtitle={websiteMaintenance.secondtitle}
                />

            </article>

            <article className='points-style'>

                <ul className='points-ul-style-1'>
                    <li>To ensure the accuracy, security, and functionality of the college website.</li>
                    <li>To provide up-to-date information for students, faculty, and stakeholders.</li>
                    <li>To enhance the user experience and accessibility.</li>
                    <li>To safeguard against cyber threats and technical issues.</li>
                </ul>
            </article>

            <article className='points-style'>
                <header>
                    <h2>Web Maintenance Plan</h2>
                </header>
                <ul className='points-ul-style-2'>
                    <li>Ensures content accuracy and relevance</li>
                    <li>Improves website security and stability.</li>
                    <li>Enhances user experience and navigation.</li>
                    <li>Boosts SEO ranking and visibility.</li>
                    <li>Ensures data protection and regulatory compliance.</li>
                </ul>
            </article>



            <article className="secondSection">
                <h2 style={{ color: "#116C4A" }}>Website Maintenance Members</h2>
                <TableComponent columns={columns} data={rows} />
            </article>
        </section>
    )
}

export default WebsiteMaintenance
